/* eslint-disable prettier/prettier */
import { useState, useEffect } from 'react';
import * as React from 'react';
import Table from "../../Tables/Table";
import Tooltip from "../../Ui/Tooltip";
import UploadFilePopup from "../../Popups/UploadFilePopup";
import Popup from "../../Popups/Popup";
import axios from "axios";
import moment from "moment";
import Input from "../../FormUi/Input";
import { PaymentStatus, PaymentStatusDescription } from "../../enums/PaymentStatus";
import Loading from "../../Ui/Loading";
import { FilterTypes } from "../../enums/TableTypes";

interface IPropsType {

}

function MyWallet(props: IPropsType) {

    const [balance, setBalance] = useState(0);
    const [history, setHistory] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [error, setError] = useState("");
    const [selectedSum, setSelectedSum] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isFinally, setIsFinally] = useState(false);
    const [head, setHead] = useState(null);
    const [head2, setHead2] = useState(null);
    const [showUpload, setShowUpload] = useState(false);
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        getHistory();
        getBalance();
    }, [])

    const payWallet = async () => {
        setIsLoading(true);
        try {
            const res = await axios.post(`/api/WalletApi/TopUpWallet?amount=${selectedSum}`);
            if (res.data?.fileUrl) {
                window.open(res.data.fileUrl, "_blank"); // Открываем PDF

                // Обновим заголовок и включим режим загрузки чека
                setHead({
                    title: "Загрузите чек",
                    description: `Счёт на ${selectedSum} ₽ успешно сформирован. Теперь загрузите квитанцию об оплате.`
                });

                setShowUpload(true); // Показываем компонент UploadFilePopup
            }

            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsFinally(true);
            setIsLoading(false);
            setHead({
                title: "Произошла ошибка",
                description: err?.response?.data?.message || "Неизвестная ошибка"
            });
        }
    };


    const getBalance = async () => {
        try {
            const res = await axios.get("/api/WalletApi/GetWalletBalance");

            setBalance(res.data.balance);
            console.log(res);
        } catch (err) {
            console.log(err);
        }
    }

    const getHistory = async () => {
        try {
            const res = await axios.get("/api/WalletApi/GetWalletOperations");

            setHistory(res.data.sort((a, b) => Number(a.StatusCode == PaymentStatus.WaitingConfirm) + Number(b.StatusCode == PaymentStatus.WaitingConfirm)));
            console.log(res);
        } catch (err) {
            console.log(err);
        }
    }

    const sendPayment = async (file) => {
        const formData = new FormData();
        formData.append("file", file[0] || file);
        setIsLoad(true);

        try {
            const res = await axios.post("/api/WalletApi/UploadWalletTopUpReceipt", formData);

            console.log(res);
            setIsOpen(true);
            setHead2({ title: "Успех", description: res.data?.message });
            getHistory();
            setIsLoad(false);
        } catch (err) {
            console.log(err);
            setIsLoad(false);
            setIsOpen(true);
            setHead2({ title: "Произошла ошибка", description: err?.response?.data || "Неизвестная ошибка" });
        }
    }

    const renderStatus = (rowData) => (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            {PaymentStatusDescription[rowData.StatusCode]}
            {rowData.StatusCode === PaymentStatus.NotAccepted && <a className="receipt"
                onClick={() => { setIsOpen(true); setHead2({ title: "Причина", description: rowData.Comment }); }}
            >Причина</a>}
        </div>
    )

    return (
        <>
            <style>
                {`
                    .tableD tbody tr.waiting {
                        background: #ffbc002e;
                    }
                `}
            </style>

            <h4 className="purpleTextHead">Мой кошелёк</h4>
            <div className="head">
                {isLoad && <Loading />}
                <div className="balance">
                    <h5>Ваш баланс:</h5>
                    <span>{balance && balance} ₽</span>
                </div>
                <div className="walletActions">
                    <button className="pay"
                        onClick={() => setIsOpen2(true)}
                    >Пополнить</button>
                    <UploadFilePopup
                        getFile={(file) => { sendPayment(file) }}
                    >
                        <Tooltip
                            side="left"
                            text="Загрузите чек об оплате"
                        >
                            <button><img src="/main-images/fileIcon.svg" /></button>
                        </Tooltip>
                    </UploadFilePopup>
                </div>
            </div>
            <div className="history">
                <Table
                    data={history}
                    columns={[
                        { name: "Type", title: "Операция" },
                        { name: "Date", title: "Дата", body: (rowData) => (moment(rowData.Date).format("DD.MM.YYYY HH:mm")) },
                        { name: "Summ", title: "Сумма", colWidth: "150px" },
                        {
                            name: "StatusCode", title: "Статус", body: renderStatus,
                            filter: {
                                init: true,
                                type: FilterTypes.dropDown,
                                placeholder: "Поиск по статусу",
                                options: Object.keys(PaymentStatus)
                                    .filter(i => !isNaN(Number(i)))
                                    .map(i => ({
                                        label: PaymentStatusDescription[i],
                                        value: Number(i),
                                    }))
                            }
                        },
                    ]}
                    rowClassName={rowData => rowData.StatusCode == PaymentStatus.WaitingConfirm ? 'waiting' : ''}
                />
            </div>

            <Popup
                isOpen={isOpen2}
                head={head ? head : { title: "Введите сумму" }}
                close={() => setIsOpen2(false)}
                loading={isLoading}
                isFinally={isFinally}
                body={
                    <>
                        {!showUpload && (
                            <Input
                                field={{ name: "summ", title: "Сумма" }}
                                onChange={(name, value) => {
                                    if (value?.trim() && !isNaN(Number(value))) {
                                        setSelectedSum(value);
                                        setError("");
                                    } else {
                                        setError("Введите число");
                                    }
                                }}
                                error={error}
                            />
                        )}

                        {showUpload && (
                            <UploadFilePopup
                                getFile={async (fileList) => {
                                    try {
                                        const file = fileList[0]; // 💥 ВАЖНО: получить первый файл из FileList
                                        if (!file) return;
                                        const formData = new FormData();
                                        formData.append("file", file);

                                        const res = await axios.post("/api/WalletApi/UploadWalletTopUpReceipt", formData, {
                                            headers: {
                                                "Content-Type": "multipart/form-data"
                                            }
                                        });

                                        if (res.data?.success) {
                                            setHead({
                                                title: "Чек загружен",
                                                description: "Квитанция об оплате успешно загружена и ожидает подтверждения администратором."
                                            });
                                        } else {
                                            setHead({
                                                title: "Ошибка",
                                                description: res.data?.message || "Ошибка при загрузке файла"
                                            });
                                        }
                                    } catch (err) {
                                        console.log(err);
                                        setHead({
                                            title: "Ошибка",
                                            description: err?.response?.data?.message || "Не удалось загрузить файл"
                                        });
                                    } finally {
                                        setShowUpload(false);
                                        setIsFinally(true);
                                    }
                                }}
                            >
                                <button className="confirm purpleGradient"
                                    style={{
                                        width: "100%",
                                        marginTop: "20px",
                                        padding: "18px 32px",
                                        color: "white",
                                        borderRadius: "30px",
                                        fontSize: "18px",
                                        fontWeight: 500,
                                        border: "none",
                                        cursor: "pointer",
                                        background: "linear-gradient(127deg, #0F0098 -29.55%, #B200FF 48.7%, #FF00F5 94.76%)"
                                    }}>
                                    Загрузить квитанцию
                                </button>
                            </UploadFilePopup>
                        )}
                    </>
                }
                actionButtons={
                    !showUpload
                        ? [{ name: "Подтвердить", action: payWallet }]
                        : []
                }
            />

            <Popup
                isOpen={isOpen}
                head={head2 ? head2 : { title: "Причина", description: "Неизвестная причина" }}
                close={() => setIsOpen(false)}
            />
        </>
    )
}

export default MyWallet;


